import * as React from 'react';

const TrophySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="trophy_svg__eds-icon--trophy_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.8 5H18V3h1V2H5v1h1v2H4.2C3 5 2 6 2 7.2c0 1.2.9 2.1 2 2.2V11h1V8.5h-.8C3.5 8.5 3 8 3 7.3S3.5 6 4.2 6H6v4c0 3.1 2.4 5.7 5.5 6v3H9v1h6v-1h-2.5v-3c3.1-.3 5.5-2.8 5.5-6V6h1.8c.7 0 1.2.6 1.2 1.3 0 .7-.5 1.2-1.2 1.2H19V11h1V9.5c1-.1 2-1 2-2.2C22 6 21 5 19.8 5zM17 10c0 2.8-2.2 5-5 5s-5-2.2-5-5V3h10v7z"
        />
        <path
            id="trophy_svg__eds-icon--trophy_line_1_"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 21h10v1H7z"
        />
    </svg>
);

TrophySvg.displayName = 'TrophySvg';
export default TrophySvg;
